import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../theme/colors';
import logo from '../../assets/logo.png';

interface SlideHeaderProps {
  title: string;
}

const SlideHeader: React.FC<SlideHeaderProps> = ({ title }) => {
  return (
    <Box sx={{ 
      bgcolor: colors.primary.main,
      p: 3,
      mb: 3,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '-24px -24px 24px -24px',
      width: 'auto',
      height: '80px'
    }}>
      <Typography variant="h4" sx={{ 
        color: '#ffffff',
        fontWeight: 500
      }}>
        {title}
      </Typography>
      <Box
        component="img"
        src={logo}
        alt="Logo"
        sx={{
          height: '60px',
          width: 'auto',
          marginLeft: 2,
          objectFit: 'contain'
        }}
      />
    </Box>
  );
};

export default SlideHeader;
